module.exports = __webpack_public_path__ + "img/Angiogenesis-CRC_10X_TGSP.83760bde.png";